import { t } from '@/utils/i18n'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Toast, Badge } from 'antd-mobile'
import useCorpSettingStore from '@/stores/corp-setting'
import useCorpInfoStore from '@/stores/corp-info'
import Stepper from '@/components/Stepper'
import styles from './ListStepper.module.less'
import type { ProductItem, UnitPriceItem } from '@/types/product'
import { cal } from '@/utils'
import ConvertOrderQuantity from '@/components/ConvertOrderQuantity/ConvertOrderQuantity'

interface ListStepperProps {
  index: number // 货品索引
  hasmultiple: false // 是否是多规格
  product: ProductItem // 商品实体
  chooseUnit: UnitPriceItem // 当前选择的单位
  onUpdateProd: (value: string, index: number) => void // 下单数量 change
  onOpenPlaceorder: (index: number) => void
}

const ListStepper: React.FC<ListStepperProps> = (props) => {
  const {
    hasmultiple = false,
    product,
    chooseUnit,
    onUpdateProd,
    onOpenPlaceorder,
    index,
  } = props
  const { corpSetting } = useCorpSettingStore()
  const { corpInfo } = useCorpInfoStore()
  const navigate = useNavigate()
  const { stockOn, cloudStoreStockType, qualityPrecision } = corpSetting
  const { accountId } = corpInfo
  const [disable, setDisable] = useState(false)

  // 判断总库存是否小于起订量
  function initBtn() {
    if (hasmultiple && stockOn) {
      const { productLockStock, unitPriceArray, productMoqUnitIndex } = product.cloudProduct;
      let currentChooseUnit = null;
      let { productStock: stock } = product.cloudProduct;

      if (unitPriceArray) {
        currentChooseUnit = unitPriceArray[productMoqUnitIndex];
      }

      // 如果云店设置显示的是可售库存，则可售库存=库存-锁定库存
      if (cloudStoreStockType === 1 && productLockStock) {
        stock = cal.minus(stock, productLockStock);
      }

      if (currentChooseUnit) {
        stock = Number(cal.getDown(
          qualityPrecision,
          cal.divide(stock, currentChooseUnit.unitRatio)
        ));
      }

      setDisable(
        Number(stock) <
          Number(product.cloudProduct.productMoqQty) ||
          !stock
      )
    }
  }

  function openPlaceOrder(event: React.MouseEvent<HTMLElement, MouseEvent>) {
    event.stopPropagation()

    if (!accountId) {
      navigate('/login')
      return
    }

    if (disable) {
      Toast.show(t('总库存小于起订量'))
    } else {
      onOpenPlaceorder(index)
    }
  }

  function handleChangeQuantity(value: string, index: number) {
    onUpdateProd(value, index)
  }

  useEffect(() => {
    initBtn()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.product])

  const multipleBtnClassNames = `${styles['multiple-btn']} ${
    disable ? 'multiple-btn-disabled' : ''
  }`

  return (
    <div className={styles['list-stepper']}>
      {hasmultiple ? (
        <div
          className={multipleBtnClassNames}
          onClick={(e) => openPlaceOrder(e)}
        >
          {t('选规格')}

          {(product.saleProduct && product.saleProduct.totalQty > 0) && (
            <Badge
              className={`${styles['multiple-btn-badge']}`}
              content={product.saleProduct.totalQty}
            ></Badge>
          )}
        </div>
      ) : (
        <div className={`${styles['stepper-bd']}`}>
          <div className={styles['stepper-box']}>
            <Stepper
              status={product.status || ''}
              initialValue={
                (product.saleProduct && product.saleProduct.details) ? product.saleProduct.details[0].quantity : 0
              }
              stock={chooseUnit.stock || 0}
              quantity={chooseUnit.productMoqQty || 0}
              unitName={chooseUnit.unitName || ''}
              onChange={handleChangeQuantity}
              isDebounce={true}
              index={index}
            />
          </div>
          <div className={styles['stepper-tip']}>
            <ConvertOrderQuantity
              moqUnitIndex={product.cloudProduct?.productMoqUnitIndex}
              quantity={(product.saleProduct && product.saleProduct.details) ? product.saleProduct.details[0].quantity : 0}
              unitList={product.cloudProduct?.unitPriceArray || []}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ListStepper
